import React from 'react';
import CustomTranslation from './CustomTranslation';

class TranslationHint extends React.Component {

    //constructor
    constructor(props) {
        super(props);
    }

    render = () => {

        if (!this.props.visible) return null;

        return (
            <div
                className={'touchable shadow rounded'}
                style={{
                    position: 'absolute',
                    top: '100%',
                    right: 0,
                    marginTop: '10px',
                    maxWidth: '220px',
                    zIndex: 20,
                    backgroundColor: '#fff'
                }}
                onClick={() => {
                    if (typeof this.props.onDismiss === 'function') {
                        this.props.onDismiss();
                    }
                }}
            >
                <div
                    style={{
                        position: 'absolute',
                        top: '-7px',
                        right: '13px',
                        width: '13px',
                        height: '13px',
                        transform: 'rotate(45deg)',
                        backgroundColor: '#fff'
                    }}
                />
                <div className={'standard-padding-2 vertical-padding-2'} style={{ position: 'relative' }}>
                    <p style={{ margin: 0 }}>
                        <CustomTranslation value={'KEY.Use this button to translate the fields bellow.'} />
                    </p>
                </div>
            </div>
        );
    }
}

//export
export default TranslationHint;
